<template>
  <div class="toggle" :class="state_class">
    <div ref="slide" class="toggle__slide" aaaaclick.self="onClick()">
      <div ref="draggable" class="toggle__draggable"></div>
    </div>
    <div class="toggle__false" @click="onClick(false)">{{ falseText }}</div>
    <div class="toggle__true" @click="onClick(true)">{{ trueText }}</div>
  </div>
</template>

<script>
export default {
  name: "BaseTrueFalse",
  props: {
    value: {
      type: Boolean,
      default: null
    },
    falseText: {
      type: String,
      default: "False"
    },
    trueText: {
      type: String,
      default: "True"
    },
    error: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      state: null
    };
  },
  computed: {
    state_class() {
      return {
        "toggle--true": this.state === true,
        "toggle--false": this.state === false,
        "toggle--active": this.state !== null,
        "toggle--is-invalid": this.hasError,
        "toggle--is-disabled": this.disabled
      };
    },
    hasError() {
      return this.error ? true : false;
    }
  },
  watch: {
    value: function(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.toggle(newValue);
      }
    }
  },
  mounted() {
    this.toggle(this.value);
  },
  methods: {
    onClick(state) {
      if (!this.disabled) {
        this.toggle(state === undefined ? !this.state : state);
        this.emit();
      }
    },
    toggle(state) {
      this.state = state;
      this.emit();
    },
    emit() {
      this.$emit("input", this.state);
    }
  }
};
</script>

<style lang="scss">
@import "@/styles/_variables";

$toggle-width: 40px !default;
$toggle-background: #fff !default;
$toggle-background-active: #72d09c !default;
$toggle-true-color: #0000ff !default;
$toggle-false-color: #ff0000 !default;
$toggle-disabled-color: #495057 !default;
$toggle-border-color: #ddd !default;
$toggle-button-size: 16px !default;
$toggle-size: 2px !default;
$toggle-button-color: $toggle-background !default;

.toggle {
  cursor: pointer;
  height: $toggle-button-size;
  position: relative;
  display: flex;
  margin: 10px 0;
  transform: translateY(-5px) translateX(-23px); // na razie zostawiam takie druciarstwo

  max-width: 150px;
  &__true,
  &__false {
    width: 50%;
    line-height: $toggle-button-size;
    opacity: 1;
    transition: opacity 0.6s;
    text-transform: uppercase;
    font-size: 0.8em;
    position: relative;
    top: -1px;
  }

  &__true {
    padding-left: $toggle-width / 2 + 10;
  }

  &__false {
    text-align: right;
    padding-right: $toggle-width / 2 + 10;
  }

  &__slide {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    // position: relative;
    width: $toggle-width;
    height: $toggle-size;
    background: $toggle-background;
    border: 1px solid $toggle-border-color;
    margin-top: ($toggle-button-size - $toggle-size) / 2 - 4;
    border-radius: 200px;
    padding: 2px;
    transition: background 0.6s;
    transform-origin: center center;
  }

  &__draggable {
    width: $toggle-button-size;
    height: $toggle-button-size;
    background: $toggle-button-color;
    border-radius: 100%;
    border: 1px solid darken($toggle-border-color, 10%);
    box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.2);
    position: absolute;
    transform: translateY(-50%);
    left: calc(50% - #{$toggle-button-size / 2});
    transition: all 0.1s linear;
  }
}

.toggle--is-invalid {
  .toggle__draggable {
    border-color: darken($col-polmed-red, 20%);
    background-color: $col-polmed-red;
  }
}

.toggle--active {
  .toggle__slide {
    background: $toggle-background-active;
    transition: background 0.6s;
  }
}

.toggle--true {
  .toggle__draggable {
    border-width: 5px;
    border-color: $toggle-true-color;
  }
  .toggle__slide {
    border-color: darken($toggle-true-color, 5%);
    background: $toggle-true-color;
  }
  .toggle__true {
    opacity: 1;
  }
  .toggle__false {
    opacity: 0.4;
  }
  .toggle__draggable {
    left: calc(100% - #{$toggle-button-size} + 3px);
  }
}

.toggle--false {
  .toggle__draggable {
    border-width: 5px;
    border-color: $toggle-false-color;
  }
  .toggle__slide {
    background: $toggle-false-color;
    border-color: darken($toggle-false-color, 5%);
  }

  .toggle__false {
    opacity: 1;
  }

  .toggle__true {
    opacity: 0.4;
  }

  .toggle__draggable {
    left: -1px;
  }
}

.toggle--is-disabled {
  .toggle__draggable {
    border-width: 5px;
    border-color: $toggle-disabled-color !important;
  }
  .toggle__slide {
    background: $toggle-disabled-color;
    border-color: darken($toggle-disabled-color, 5%);
  }
}
</style>
